import { Sede } from '../../models/Entities/Turnero';
import { ErrorType } from '../../models/HttpError';

export const TURNERO_SEDES_GET_ALL_REQUEST = 'TURNERO-SEDES_GET_ALL_REQUEST';
export const TURNERO_SEDES_GET_ALL_SUCCESS = 'TURNERO-SEDES_GET_ALL_SUCCESS';
export const TURNERO_SEDES_GET_ALL_FAILURE = 'TURNERO-SEDES_GET_ALL_FAILURE';

export interface TurneroSedesGetAllRequestAction {
    type: typeof TURNERO_SEDES_GET_ALL_REQUEST;
}

export interface TurneroSedesGetAllSuccessAction {
    type: typeof TURNERO_SEDES_GET_ALL_SUCCESS;
    payload: Sede[];
}

export interface TurneroSedesGetAllFailureAction {
    type: typeof TURNERO_SEDES_GET_ALL_FAILURE;
    error: ErrorType;
}

export const TURNERO_SEDES_CREATE_REQUEST = 'TURNERO-SEDES_CREATE_REQUEST';
export const TURNERO_SEDES_CREATE_SUCCESS = 'TURNERO-SEDES_CREATE_SUCCESS';
export const TURNERO_SEDES_CREATE_FAILURE = 'TURNERO-SEDES_CREATE_FAILURE';

export interface TurneroSedesCreateRequestAction {
    type: typeof TURNERO_SEDES_CREATE_REQUEST;
    payload: Sede;
}

export interface TurneroSedesCreateSuccessAction {
    type: typeof TURNERO_SEDES_CREATE_SUCCESS;
    payload: Sede;
}

export interface TurneroSedesCreateFailureAction {
    type: typeof TURNERO_SEDES_CREATE_FAILURE;
    error: ErrorType;
}

export const TURNERO_SEDES_UPDATE_REQUEST = 'TURNERO-SEDES_UPDATE_REQUEST';
export const TURNERO_SEDES_UPDATE_SUCCESS = 'TURNERO-SEDES_UPDATE_SUCCESS';
export const TURNERO_SEDES_UPDATE_FAILURE = 'TURNERO-SEDES_UPDATE_FAILURE';

export interface TurneroSedesUpdateRequestAction {
    type: typeof TURNERO_SEDES_UPDATE_REQUEST;
    id: number;
    payload: Sede;
}

export interface TurneroSedesUpdateSuccessAction {
    type: typeof TURNERO_SEDES_UPDATE_SUCCESS;
    id: number;
    payload: string;
    /** Lo enviado en el PUT (el back no devuelve la sede). */
    sede?: Sede;
}

export interface TurneroSedesUpdateFailureAction {
    type: typeof TURNERO_SEDES_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_SEDES_DELETE_REQUEST = 'TURNERO-SEDES_DELETE_REQUEST';
export const TURNERO_SEDES_DELETE_SUCCESS = 'TURNERO-SEDES_DELETE_SUCCESS';
export const TURNERO_SEDES_DELETE_FAILURE = 'TURNERO-SEDES_DELETE_FAILURE';

export interface TurneroSedesDeleteRequestAction {
    type: typeof TURNERO_SEDES_DELETE_REQUEST;
    id: number;
}

export interface TurneroSedesDeleteSuccessAction {
    type: typeof TURNERO_SEDES_DELETE_SUCCESS;
    payload: number;
}

export interface TurneroSedesDeleteFailureAction {
    type: typeof TURNERO_SEDES_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
